import { mergeSubsAndDevices } from './subscriptions';

export const injectDeviceIntoLineItems = (
  subscriptionsData,
  chargesData,
  devicesData,
) => {
  if (!chargesData?.charges) {
    return [];
  }

  const subsWithDevices = mergeSubsAndDevices(subscriptionsData, devicesData);
  return chargesData.charges?.map((charge) => {
    const updatedLineItems = charge.line_items.map((item) => {
      const sub = getSubForLineItem(item, subsWithDevices);
      return {
        ...item,
        meta: sub?.meta || null,
      };
    });
    return {
      ...charge,
      line_items: updatedLineItems,
    };
  });
};

export const injectPaymentsDataIntoCharge = (charges, paymentsData) => {
  return charges?.map((charge) => {
    let paymentDetails = null;
    if (paymentsData?.paymentsData) {
      paymentDetails = paymentsData?.paymentsData?.find(
        (paymentData) =>
          paymentData?.id === charge?.external_order_id?.ecommerce,
      );
    }
    return {
      ...charge,
      paymentDetails: paymentDetails?.data || null,
    };
  });
};

export const getSubForLineItem = (item, subs) => {
  if (!subs || item.purchase_item_type !== 'subscription') {
    return null;
  }

  const sub = subs.find((sub) => sub.id === item.purchase_item_id);

  return sub ? sub : null;
};
